import React from 'react';
import styled from 'styled-components';

export const WCard = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.stroke};
  border-radius: 6px;
  overflow: hidden;
  display: grid;
  min-height: 88px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    min-height: 74px;
  }
`;
